import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "my-no-more" }, null, -1)

import {
  ref,
  reactive,
  toRefs
} from 'vue'
import type { PropType } from 'vue'
import {
  VueEternalLoading,
  LoadAction
} from '@ts-pro/vue-eternal-loading'
import ProgressSpinner from 'primevue/progressspinner'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'

export type TSlotDefaultParamVS<TData> = {
  items: TData[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VirtualScroll',
  props: {
  endpoint: {
    type: String,
    default: ''
  },
  totalRow: {
    type: Number,
    default: 10
  },
  fieldSearch: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  searchValue: {
    type: String,
    default: ''
  },
  filters: {
    type: Array as PropType<string[][]>,
    default: () => []
  },
},
  setup(__props, { expose }) {

const props = __props



const {
  endpoint,
  totalRow,
  searchValue,
  filters
} = toRefs(props)

const items = ref<any[]>([])

const paginate = reactive({
  pageSize: totalRow.value,
  pageNumber: 1,
  totalRecords: 0,
})

const tempLengthOfList = ref(0)
const getAllData = async (reset = false) => {
  const {
    result,
    error
  } = await apiUseCase.get(`${endpoint.value}${returnUrlPrams({
    pageNumber: paginate.pageNumber,
    pageSize: paginate.pageSize,
    search: searchValue.value,
    custom: filters.value
  })}`)
  if (!error) {
    if (reset) {
      items.value = []
    }
    tempLengthOfList.value = result.length
    items.value = [...items.value, ...result]
    paginate.pageNumber += 1
  }
}

const isInitial = ref(false)
/** Fungsi emit dri child FormAssigCourier */
const reloadData = async () => {
  // store.dispatch('showLoading')
  paginate.pageNumber = 0
  await getAllData(true)
  isInitial.value = true
  // store.dispatch('hideLoading')
}

/** Menggunakan load data untuk plugin pagination */
const loadData = async ({ loaded, noMore }: LoadAction) => {
  getAllData(isInitial.value).then(() => {
    if (tempLengthOfList.value < paginate.pageSize) {
      /** menggunakan fungsi unutuk mereset state data kosong type dri interface plugin vue-eternal-loading */
      noMore()
    } else {
      /** menggunakan fungsi unutuk load state type dri interface plugin vue-eternal-loading */
      loaded()
    }
  })
}

expose({
  reloadData
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ items: items.value }))),
    _createVNode(_unref(VueEternalLoading), {
      load: loadData,
      "is-initial": isInitial.value,
      "onUpdate:is-initial": _cache[0] || (_cache[0] = ($event: any) => ((isInitial).value = $event)),
      class: "flex justify-center"
    }, {
      loading: _withCtx(() => [
        _createVNode(_unref(ProgressSpinner), {
          class: "h-8",
          strokeWidth: "5"
        })
      ]),
      "no-more": _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["is-initial"])
  ]))
}
}

})